<template>
  <div class="statement-content">
    <div class="sc-head">
      <p class="sc-company">北京青牛技术股份有限公司</p>
      <h2 class="sc-title">关于公司名称被冒用发布虚假招聘信息的严正声明</h2>
    </div>
    <div class="sc-body">
      <p>近期，我司北京青牛技术股份有限公司（统一社会信用代码：91110108769350528G）发现，有不法分子未经任何授权，冒用我司企业名称、字号、Logo及业务信息，通过境外免费注册的电子邮件账户（如Gmail、Outlook、ProtonMail、Yahoo等域名的邮箱），向不特定求职者批量发送所谓“面试邀请函”、“录用通知”、“入职须知”等邮件，以我司名义进行招聘面试，并以此诱导求职者扫描二维码、添加私人微信、加入非官方群组，或进一步以“岗前培训费”、“体检费”、“保证金”、“内推服务费”等名义实施诈骗或非法获取求职者个人信息。</p>
      <p><span style="font-weight: bold;">经我司核查确认，</span>上述邮件并非我司发送，亦非我司授权任何第三方发送。我司从未委托、亦从未与任何使用境外免费邮箱的主体建立招聘合作关系。我司官方招聘沟通渠道仅限以下方式：</p>
      <ul class="sc-channels">
        <li>官方企业邮箱（域名：<strong>@channelsoft.com</strong>）</li>
        <li>官方网站：<strong>https://www.channelsoft.com</strong></li>
        <li>官方招聘平台：<strong>Boss直聘</strong></li>
        <li>官方联系电话：<strong>010-888822000</strong></li>
      </ul>
      <p><span style="font-weight: bold;">我司郑重提示：</span>凡以Gmail、Outlook、ProtonMail、Yahoo等境外免费邮箱发送所谓“北京青牛技术股份有限公司面试邀请”、“北京青牛技术股份有限公司录用通知”的，均属冒用或伪造，与我司无关。凡要求求职者向个人账户、第三方公司账户转账缴费的，均属诈骗行为；凡以“内推保录”、“直签国企”、“无需面试直接入职”等话术诱导求职者缴纳费用的，均属虚假招聘。<strong class="sc-strong">我司绝不以任何名义向求职者收取报名费、体检费、培训费、押金、服装费、内推费、保证金等任何费用。</strong></p>
      <p><span style="font-weight: bold;">我司已就上述冒用行为正式向公安机关报案（报案时间：2026年9月24日，报案单位：北京市公安局石景山分局新古城派出所），详见附件《北京市公安局石景山分局接报回执》。</span>冒用我司名称发送虚假招聘邮件的行为，已严重侵害我司名称权、商誉权，涉嫌构成诈骗、伪造企业印章、侵犯公民个人信息等违法犯罪，我司将依法追究冒用者及相关引流、支付通道主体的民事、行政及刑事责任，对于未尽到招聘信息发布审核义务、致使冒名信息持续传播的平台，我司将依据相关法律法规及监管规定，依法主张权利。</p>
      <p><span style="font-weight: bold;">请广大求职者注意：</span>收到以我司名义发送的邮件时，务必核对该邮件是否来自我司官方域名邮箱，凡发件邮箱为境外免费邮箱（如@gmail.com、@outlook.com、@proton.me等）且自称代表我司的，一律视为伪造，如已向冒用者转账或提交个人身份信息，请立即停止进一步操作，保存聊天记录、邮件原文、转账凭证，并向当地公安机关报案。如有疑问，请通过上述官方渠道与我司核实。</p>
      <p class="sc-end">特此声明！</p>
      <div class="sc-sign">
        <p>北京青牛技术股份有限公司</p>
        <p>2026年9月24日</p>
      </div>
      <div class="sc-attachment">
        <p class="sc-attachment-title">附件：北京市公安局石景山分局接报回执</p>
        <el-image
          class="sc-receipt"
          :src="receipt"
          :preview-src-list="previewList"
          :z-index="3600"
          fit="contain"
          alt="北京市公安局石景山分局接报回执">
        </el-image>
        <p class="sc-attachment-tip">（点击图片可放大查看）</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatementContent',
  data () {
    return {
      receipt: require('../assets/statement_receipt.png')
    }
  },
  computed: {
    previewList: function () {
      return [this.receipt]
    }
  }
}
</script>

<style scoped>
.statement-content {
  text-align: left;
}
.sc-head {
  text-align: center;
  padding: 6px 10px 0;
}
.sc-company {
  font-size: 16px;
  color: #333333;
  font-weight: 600;
  letter-spacing: 4px;
  margin: 0 0 10px;
}
.sc-title {
  font-size: 21px;
  line-height: 1.5;
  color: #18386e;
  font-weight: bold;
  margin: 0;
}
.sc-title-line {
  display: inline-block;
  width: 62px;
  height: 3px;
  background: #ff882f;
  margin-top: 14px;
}
.sc-body {
  margin-top: 18px;
}
.sc-body p {
  font-size: 15px;
  line-height: 2;
  color: #333333;
  text-align: justify;
  text-indent: 2em;
  margin: 10px 0;
}
.sc-strong {
  color: #c0161c;
}
.sc-end {
  font-weight: 600;
}
.sc-channels {
  margin: 14px 0 14px 2em;
  padding: 14px 20px 14px 36px;
  background: #f5f8fd;
  border-left: 3px solid #18386e;
}
.sc-channels li {
  font-size: 15px;
  line-height: 2.1;
  color: #333333;
  position: relative;
}
.sc-channels li + li {
  margin-top: 2px;
}
.sc-channels li::before {
  content: '';
  position: absolute;
  left: -16px;
  top: 50%;
  margin-top: -3px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ff882f;
}
.sc-channels strong {
  color: #000;
}
.sc-sign {
  margin-top: 26px;
}
.sc-sign p {
  text-indent: 0;
  text-align: right;
  font-weight: 600;
  color: #000;
  margin: 4px 0;
}
.sc-attachment {
  margin-top: 30px;
  text-align: center;
}
.sc-attachment-title {
  text-indent: 0;
  text-align: center;
  font-weight: 600;
  margin-bottom: 4px;
}
.sc-receipt {
  display: block;
  width: 300px;
  max-width: 80%;
  margin: 14px auto 0;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  background: #ffffff;
  cursor: zoom-in;
}
.sc-receipt >>> img {
  display: block;
  width: 100%;
  height: auto;
}
.sc-attachment-tip {
  text-indent: 0;
  text-align: center;
  color: #999999;
  font-size: 13px;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/StatementContent.vue